import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from 'primereact/button';
import { QADropdown } from '../../shared/QADropdown';
import { QACheckbox } from '../../shared/QACheckbox';
import { Fetch } from '../../shared/Fetch';

export interface FilterValues {
    status?: boolean | null;
    testType?: boolean | null;
    projectID: number | null,
}

export interface IProjectsDropdown {
    id: number;
    project_Name: string;
    status?: boolean;
}

export const initialFilter: FilterValues = {
    status: null,
    testType: null,
    projectID: null,
};

const schema = yup.object().shape({
    status: yup.boolean().nullable(),
    testType: yup.boolean().nullable(),
    projectID: yup.number().nullable(),
});

interface Iprops {
    filter: FilterValues,
    setFilter: (filter: FilterValues) => void,
}

export const Filter = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [projects, setProjects] = useState<Array<IProjectsDropdown>>();
    const loginObj = JSON.parse(sessionStorage.getItem('loginData') || "{}");

    const Status = [
        { label: "--Select--", status: null },
        { label: "Pass", status: true },
        { label: "Fail", status: false }
    ];
    const TestType = [
        { label: "--Select--", status: null },
        { label: "Postive", status: true },
        { label: "Negative", status: false }
    ];

    const { control, handleSubmit, formState: { errors }, reset } = useForm<FilterValues>({
        resolver: yupResolver(schema as any),
        defaultValues: {}
    });

    const loadCompanies = async () => {
        const response = await Fetch("Projects", "GET", null, null, null);
        if (response) {
            const data: Array<IProjectsDropdown> = await response.json();
            const emptyData: IProjectsDropdown = { id: 0, project_Name: "-- SELECT --" };
            data.unshift(emptyData);
            setProjects(data);
        }
    }

    const onSubmit = (data: FilterValues) => {
        setLoading(true);
        props.setFilter(data);
        setLoading(false);
    }

    useEffect(() => {
        loadCompanies();
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <QADropdown column={2} label="Project" control={control} name="projectID" options={projects} optionLabel="project_Name" optionValue="id" placeholder="Select Project" />
            <QADropdown column={2} control={control} label="Status" name="status" options={Status} optionLabel="label" optionValue="status" placeholder="Select Status" />
            <QADropdown column={2} control={control} label="Test Type" name="testType" options={TestType} optionLabel="label" optionValue="status" placeholder="Select Test Type" />
            
            <div className="col-12 md:col-12 flex justify-content-end gap-4">
                    <Button type="submit" label="Search" loading={loading} className="p-button-sm" rounded/>
                    <Button type="button" label="Clear" severity="secondary" outlined onClick={() => reset(initialFilter)} className="p-button-sm" rounded/>
            </div>
        </form>
    )
}
